export default __webpack_public_path__ + "static/cafe_36071-c5f0e2a5c5c31f805e16f548e607773e.png";